<template>
  <SectionFrame v-if="areas.length || html" :section="section" :index="index" :heading="section.title || 'Areas we cover'" label="Areas we cover">
    <div class="s2-areas" :data-layout="layout">
      <div class="mo-reveal">
        <div v-if="html" class="t-body" v-html="html"></div>
        <ul class="s2-chips">
          <li v-for="a in areas" :key="a" class="t-badge s2-chip">{{ a }}</li>
        </ul>
      </div>
      <img v-if="layout === 'map' && imageUrl" :src="imageUrl" v-bind="imgAttrs(imageUrl, '(min-width: 768px) 50vw, 100vw')" alt="" class="t-photo s2-areas-img mo-reveal" loading="lazy">
    </div>
  </SectionFrame>
</template>

<script setup>
import {imgAttrs} from "@/utils/photoSizes.js";
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";
import {layoutOf} from "@/utils/sectionLogic.js";
import {safeMarkdown} from "@/utils/safeMarkdown.js";

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}});
const layout = computed(() => layoutOf(props.section, ["list", "map"]));
const html = computed(() => safeMarkdown(props.section.content || ""));
const areas = computed(() => (Array.isArray(props.section.areas) ? props.section.areas : [])
  .map((a) => (typeof a === "string" ? a : a?.name || "")).map((a) => a.trim()).filter(Boolean));
const imageUrl = computed(() => props.section.image?.url || "");
</script>

<style>
.s2-areas { display: grid; grid-template-columns: minmax(0, 1fr); gap: var(--t-gap); }
.s2-areas[data-layout="map"] { grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); align-items: center; }
@media (max-width: 760px) { .s2-areas[data-layout="map"] { grid-template-columns: minmax(0, 1fr); } }
.s2-chips { list-style: none; padding: 0; margin: 1rem 0 0; display: flex; flex-wrap: wrap; gap: .5rem; }
.s2-chip { text-transform: none; letter-spacing: 0; font-size: .9rem; }
.s2-areas-img { width: 100%; height: auto; aspect-ratio: 4 / 3; object-fit: cover; }
</style>
